import { style } from "typestyle"
import { Rotator_Box } from "../Components/Rotator_Box"

export function Splash_Main_Content() {

    return (
		<>
		<div className={splash_vertical_style}>
			<div className={carousel_item_style}>
				<div className={centre_style} onClick={() => {console.log('rotate!')}}>
					<div className={rotator_centre_style}>
						<Rotator_Box size={16} letters="QUIZBZ"/>
					</div>
				</div>

			</div>
		</div>
	</>)
}

const centre_style = style({
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
	justifyContent: 'space-around',
})

const rotator_centre_style = style({
	margin: 'auto'
})


const splash_vertical_style = style({
    display: 'flex',
    flexDirection: 'column',
	width: '100%',
	flex: 1,
})

const carousel_item_style = style({
	padding: '1.5em 1em 1em 1em',
    display: 'flex',
    height: '100%',
	flexDirection: 'column',
	justifyContent: 'flex-start',
	background: 'rgba(227, 187, 91, 0.76)',
	borderRadius: '1em',
	backdropFilter: 'blur(4.1px)',
	border: '1px solid rgba(255, 255, 255, 0.3)',
	margin: '0 0.35rem 1.35rem',
})

